<template>
   <form @submit="Submit" v-if="(notSubmitted == true) ">

    
    <div class="row">

        <div class="col">
            <div class="mb-12">
                <label :for="contractid">
                    <DropdownInputSearchable input-id="contractId" :options="contractDropdownValues" :my-errors="v$.editedUserContract.contractId.$errors" @update-form="UpdateForm" @blur="v$.editedUserContract.contractId.$touch" object-key="contractId" placeholder="Select, or Search for a Contract" label-text="Contract:" :input-v-model="editedUserContract.contractId" search-key="contractNumber" :search-value-model="editedUserContract.contractNumber"></DropdownInputSearchable>
                    my label
                </label>

            </div>
        </div>

    </div>

    <div class="row">

        <div class="col">
            <div class="mb-12">
               
                <DropdownInputVue input-id="userProfileId" label-text="User Profile:" :input-v-model="this.editedUserContract.userProfileId" object-key="userProfileId" :option-list="this.userProfileDropdownValues" @update-form="UpdateForm" @blur="v$.editedUserContract.userProfileId.$touch" :my-errors="v$.editedUserContract.userProfileId.$errors"  :disabled="disabled" ></DropdownInputVue>


            </div>
        </div>

    </div>

    <div class="row">

        <div class="col">
            <div class="mb-12">

                <RadioBoolInputVue input-id="flexRadioDefault" :input-v-model="editedUserContract.isActive" object-key="isActive" bool-true-text="Active" bool-false-text="Inactive" @update-form="UpdateForm" @blur="v$.editedUserContract.isActive.$touch" :my-errors="v$.editedUserContract.isActive.$errors" ></RadioBoolInputVue>

            </div>
        </div>

    </div>

    <div class="row" v-if="(editedUserContract.updateDate != null)">

        <div class="col">
            <div class="mb-12">

                <label :for="updateDate" class="form-label">Last Updated:</label>
                <span id="updateDate" class="displayDate">{{this.editedUserContract.updateDatePretty}}</span>
            </div>
        </div>

    </div>
</form>

</template>

<script> 

import { store } from "@/store/store.js"
import $ from "jquery";
import { useVuelidate } from '@vuelidate/core'
import { ajaxGetAndReturn } from "@/components/helpers/utilities";
import DropdownInputVue from "@/components/formComponents/DropdownInput.vue";
import DropdownInputSearchable from "@/components/formComponents/DropdownInputSearchable.vue";
import RadioBoolInputVue from "@/components/formComponents/RadioBoolInput.vue";
import { required, minValue, helpers} from '@vuelidate/validators'; 

export default {
  name: "UserContractsForm",
  components: {
    DropdownInputVue,RadioBoolInputVue,DropdownInputSearchable
  }, 
  setup () {
    return { v$: useVuelidate() }
  },
  data() {
      return {
        buttonText: "Save User Contract",
        successMessage: "",
        notSubmitted:true,
        editedUserContract:{},
        contractDropdownValues: []
      };
    },
    props: {
        loadedUserContract:Object,
    },
    watch:{
        loadedUserContract(newVal,oldVal){

            oldVal; newVal;
            //this.editedUserContract.campName = newVal.campName; 
        }
    },
    mounted() {
        this.editedUserContract.isActive = null; 
        this.editedUserContract = this.loadedUserContract;
        
        this.buttonText = "Save Changes to User Contract";

        ajaxGetAndReturn(store.webAPIUrl + "Contracts/getDropdown", (result) =>{
            this.contractDropdownValues = result; 
        });

        ajaxGetAndReturn(store.webAPIUrl + "UserProfiles/getDropdown", (result) =>{
            this.userProfileDropdownValues = result; 
            //console.log(result);
        });
    },
    methods:{
        UpdateForm(objKey, modelData){
            console.log("Updating user contract form", modelData,objKey);
            this.editedUserContract[objKey] = modelData;
        },
        async Submit(){

            const isFormCorrect = await this.v$.$validate();
            // you can show some extra alert to the user or just leave the each field to show it's `$errors`.
            if (!isFormCorrect) return;

            var method = "POST";
            var actionUrl = store.webAPIUrl + "ContractUserProfiles"; 

            this.editedUserContract.createDate = new Date();
            this.editedUserContract.updateDate = new Date();

            if(this.editedUserContract.contractUserProfileId != null && this.editedUserContract.contractUserProfileId != 0){
                method = "PUT";
                actionUrl += "/" + this.editedUserContract.contractUserProfileId;
            }

            $.ajax({
                method: method,
                data: JSON.stringify(this.editedUserContract),
                contentType: "application/json; charset=utf-8",
                dataType: "json",
                url: actionUrl,
                success: (result) => {

                    var successMessage = "Successfully Submitted Change to DB on: " + Date().toLocaleString() + "; " + result;
                    //console.log(successMessage);
                    successMessage;
                    this.$emit("userContractFormSubmitted");
                },
            });

            //console.log("hit submit user contracts form");
        }
    },
     validations () {
        return {
            editedUserContract:{
                isActive:{
                    required: helpers.withMessage("Active is Required.", required)
                },
                contractId: {
                    minValue: helpers.withMessage("Contract is Required", minValue(1)),
                },
                userProfileId: {
                    minValue: helpers.withMessage("User Profile is Required", minValue(1))
                }
            },
        }
    },

}
</script>

<style>
.lucasForm{
    width:100%;
    display:flex;
    flex-wrap:wrap;
    justify-content:space-around;
}
.formElement{
    flex-basis:40%;
    margin-right:15px;
    margin-top:15px;
}
    .errorMessageForm {
        color: #DC143C;
        font-size: 12px;
        text-align: left;
    }
.form-label{
    font-weight: bold;
    font-size: 14px;
    float: left;
}
#successMessage{
    display: flex;
    font-size: 12px;
    color: green;
}
.displayDate{
    display: inline-block;
    width:100%;
    text-align: left;
}

</style>